import React, { useCallback, useState, useEffect } from 'react'
import styled from 'styled-components'
import Label from 'ui-components/lib/components/Label'
import Spinner from 'ui-components/lib/components/Spinner'

const Container = styled.ul`
  list-style: none;
  margin: 0;
  padding: 5px 10px;
  border: solid 1px var(--border-color);
  border-radius: 8px;
  max-height: 350px;
  overflow: auto;
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  z-index: 999999 !important;
  margin-top: 0;
  background: var(--card-bg) !important;
  box-shadow: 0 4px 12px var(--shadow-color) !important;
  opacity: 1 !important;
  visibility: visible !important;
  transition: background-color 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;

  li {
    min-width: 100%;
  }
`

const Button = styled.button`
  border: 0;
  width: 100%;
  padding: 10px;

  display: flex;
  align-items: flex-start;
  background: var(--card-bg);
  border-radius: 6px;
  color: var(--text-color);
  transition: background-color 0.3s ease, color 0.3s ease;

  :focus {
    outline: 0;
  }
  :hover {
    background: var(--card-hover-bg);
  }
`

const SearchSuggestions = ({ suggestions, loading, setSearchResult, searchBlur, searchResult, handleChangeSearchTerm, setSearchTerm }) => {
  const [hidden, setHidden] = useState(false)

  const handleSelectedSubservice = useCallback(
    async ({ serviceId, subservice, service, serviceType, title, description }) => {
      setSearchResult({
        serviceId,
        subservice,
        title,
        description,
        service,
        serviceType
      })
      setHidden(true)
      setSearchTerm(title)
    },
    [setSearchResult, searchResult, hidden] //eslint-disable-line
  )

  useEffect(() => {
    if (!searchBlur) setHidden(false)
  }, [searchBlur])

  if (suggestions?.length === 0)
    return (
      <Container hidden={searchBlur}>
        <li>
          <Label color="var(--text-secondary)">Nenhum serviço foi encontrado.</Label>
        </li>
      </Container>
    )

  if (loading)
    return (
      <Container style={{ 
        position: 'absolute', 
        top: 'calc(100% + 4px)', 
        left: 0, 
        right: 0, 
        zIndex: 999999, 
        marginTop: 0,
        background: 'var(--card-bg)',
        border: '1px solid var(--border-color)',
        borderRadius: '8px',
        boxShadow: '0 4px 12px var(--shadow-color)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
        minHeight: '80px',
        opacity: 1,
        visibility: 'visible'
      }}>
        <Spinner color="primary" />
      </Container>
    )

  return (
    <Container hidden={hidden && searchBlur}>
      {suggestions?.length > 0 &&
        suggestions?.map((suggestion) => (
          <li key={suggestion._id}>
            <Button
              onClick={() =>
                handleSelectedSubservice({
                  service: suggestion.service,
                  serviceId: suggestion.service._id,
                  subservice: suggestion,
                  serviceType: suggestion.serviceType,
                  title: suggestion.serviceFullName,
                  description: suggestion.description,
                })
              }
            >
              <Label color="var(--text-secondary)">{suggestion.serviceFullName}</Label>
            </Button>
          </li>
        ))}
    </Container>
  )
}

export default SearchSuggestions
